export default __webpack_public_path__ + "static/media/home-activities-lectures-mobile.638c6504.png";